/**
 * @generated SignedSource<<8913887bddf35991a696c0dbed9bb08b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardColumnOld_project$data = {
  readonly canCreateIssues: {
    readonly canPerform: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"BoardCard_project" | "StatusColumnHeaderOld_project">;
  readonly " $fragmentType": "BoardColumnOld_project";
};
export type BoardColumnOld_project$key = {
  readonly " $data"?: BoardColumnOld_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardColumnOld_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardColumnOld_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "canCreateIssues",
        "args": [
          {
            "kind": "Literal",
            "name": "type",
            "value": "CREATE_ISSUES"
          }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "canPerform"
            },
            "action": "THROW",
            "path": "canCreateIssues.canPerform"
          }
        ],
        "storageKey": "action(type:\"CREATE_ISSUES\")"
      },
      "action": "THROW",
      "path": "canCreateIssues"
    },
    {
      "kind": "FragmentSpread",
      "name": "StatusColumnHeaderOld_project"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardCard_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "c1932aedcabd6f5f0c995c9a99c502e6";

export default node;
